import React, { Component } from 'react';
import { StateCombobox } from './StateCombobox';
import FloatingLabelInput from './FloatingLabelInput';

function isValidDate(str) {
  // Accepts yyyy-mm-dd
  if (!str) return true;
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!regex.test(str)) return false;
  const date = new Date(str);
  return !isNaN(date.getTime()) && str === date.toISOString().slice(0, 10);
}

// Map field names to their validation functions and error messages
const fieldValidators = {
  requestDate: {
    validate: isValidDate,
    error: 'Invalid date (yyyy-mm-dd)'
  },
  patientDob: {
    validate: isValidDate,
    error: 'Invalid date (yyyy-mm-dd)'
  }
};

export class SearchPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {}
    };
    this.searchParams = props.searchParams;
  }

  handleFieldChange = (field) => (e) => {
    const value = e.target.value;
    let error = '';
    if (fieldValidators[field]) {
      if (value && !fieldValidators[field].validate(value)) {
        error = fieldValidators[field].error;
      }
    }
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [field]: error
      }
    }));
    this.props.handleChangeProps({ [field]: value });
  };

  render() {
    const searchParams = this.props.searchParams;
    const { errors } = this.state;
    return (
      <form>
        <div className='px-md-3'>
          <div className='row justify-content-start'>
            <div className='col-md-2 px-md-1'>
              <StateCombobox selectedState={searchParams.authorityName} onChangeState={(e) => this.props.handleChangeProps({ authorityName: e })} />
            </div>
            <div className='col-md-3 px-md-1'>
              <FloatingLabelInput
                id="requestDate"
                label="Request date (yyyy-mm-dd)"
                backcolor="white"
                value={searchParams.requestDate}
                onChange={this.handleFieldChange('requestDate')}
                readOnly={false}
                error={errors.requestDate}
              />
            </div>
            <div className='col-md-4 px-md-1'>
              <FloatingLabelInput
                id="requestId"
                label="Request Identity"
                backcolor="white"
                value={searchParams.requestId}
                onChange={e => this.props.handleChangeProps({ requestId: e.target.value })}
                readOnly={false}
              />
            </div>
          </div>
          <div className='row justify-content-start'>
            <div className='col-md-3 px-md-1'>
              <FloatingLabelInput
                id="patientDob"
                label="Patient Dob (yyyy-mm-dd)"
                backcolor="white"
                value={searchParams.patientDob}
                onChange={this.handleFieldChange('patientDob')}
                readOnly={false}
                error={errors.patientDob}
              />
            </div>
            <div className='col-md-3 px-md-1'>
              <FloatingLabelInput
                id="patientLastName"
                label="Patient LastName"
                backcolor="white"
                value={searchParams.patientLastName}
                onChange={e => this.props.handleChangeProps({ patientLastName: e.target.value })}
                readOnly={false}
              />
            </div>
            <div className='col-md-3 px-md-1'>
              <FloatingLabelInput
                id="patientFirstName"
                label="Patient FirstName"
                backcolor="white"
                value={searchParams.patientFirstName}
                onChange={e => this.props.handleChangeProps({ patientFirstName: e.target.value })}
                readOnly={false}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
